// extracted by mini-css-extract-plugin
export default {"root":"applications-components-ProductsApp-components-Clients-examples-module__root","title":"applications-components-ProductsApp-components-Clients-examples-module__title","slider":"applications-components-ProductsApp-components-Clients-examples-module__slider"};
    if(module.hot) {
      // 1791528099284
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  